import ReactDOM from 'react-dom';
import _ from 'lodash';
export var getBoundingRect = function getBoundingRect(node) {
  return ReactDOM.findDOMNode(node).getBoundingClientRect();
};
export var getRectByBoundingRect = function getRectByBoundingRect(boundingRect) {
  return {
    x: boundingRect.left,
    y: boundingRect.top,
    width: boundingRect.width,
    height: boundingRect.height
  };
};
export var getStyleByRect = function getStyleByRect(rect) {
  return {
    left: rect.x,
    top: rect.y,
    width: rect.width,
    height: rect.height
  };
};
export var getRectByReactElement = function getRectByReactElement(elem) {
  return _(elem).thru(getBoundingRect).thru(getRectByBoundingRect).value();
};